<axs-modal #modal class="introduction-modal" [attr.axs-size]="'wide'" [attr.axs-prevent-click-outside]="true" *ngIf="showModal">
  <dialog #dialog>
    <axs-modal-close>
      <ngx-axs-button
        [axsText]="commonContent?.close || 'Close'"
        axsType="supplementary"
        axsTheme="black"
        axsIconType="close"
        (axsClick)="closeModal()"
      />
    </axs-modal-close>
    <axs-modal-content>
      <div class="introduction-modal__content-wrapper">
    <section id="slides" class="axs-flex slide-show">
      <div class="axs-flex-inner-wrapper--full-width">

        <!-- Slide 1 -->
        <ng-container
          *ngIf="activeSlide === 0"
          [ngTemplateOutlet]="slide"
          [ngTemplateOutletContext]="{
            heading: modalContent?.modal1Header,
            description: modalContent?.modal1Intro,
            secondaryDescription: modalContent?.modal1Conclusion,
            next: true,
            image: 'assets/images/introduction-modal/RCC-Walkthrough-1.gif'
          }"
        ></ng-container>

        <!-- Slide 2 -->
        <ng-container
          *ngIf="activeSlide === 1"
          [ngTemplateOutlet]="slide"
          [ngTemplateOutletContext]="{
            heading: modalContent?.modal2Header,
            description: modalContent?.modal2Intro,
            secondaryDescription: modalContent?.modal2Conclusion,
            next: true,
            image: 'assets/images/introduction-modal/RCC-Walkthrough-2.gif'
          }"
        ></ng-container>

        <!-- Slide 3 -->
        <ng-container
          *ngIf="activeSlide === 2"
          [ngTemplateOutlet]="slide"
          [ngTemplateOutletContext]="{
            heading: modalContent?.modal3Header,
            description: modalContent?.modal3Conclusion,
            next: true,
            image: 'assets/images/introduction-modal/RCC-Walkthrough-3.gif'
          }"
        ></ng-container>

        <!-- Slide 4 -->
        <ng-container
          *ngIf="activeSlide === 3"
          [ngTemplateOutlet]="slide"
          [ngTemplateOutletContext]="{
            heading: modalContent?.modal4Header,
            description: modalContent?.modal4Conclusion,
            next: true,
            image: 'assets/images/introduction-modal/RCC-Walkthrough-4.gif'
          }"
        ></ng-container>

        <!-- Slide 5 -->
        <ng-container
          *ngIf="activeSlide === 4"
          [ngTemplateOutlet]="slide"
          [ngTemplateOutletContext]="{
            heading: modalContent?.modal5Header,
            description: modalContent?.modal5Conclusion,
            useTool: true,
            image: 'assets/images/introduction-modal/RCC-Walkthrough-5.gif'
          }"
        ></ng-container>
      </div>
    </section>
    
    <!-- Pagination Dots -->
    <section id="introduction-modal-nav">
        <span
          class="introduction-modal__dot introduction-modal__dot-spacing"
          (click)="goToSlide(0)"
          [ngClass]="{ 'introduction-modal__dot--selected': activeSlide === 0 }"
        ></span>
        <span
          class="introduction-modal__dot introduction-modal__dot-spacing"
          (click)="goToSlide(1)"
          [ngClass]="{ 'introduction-modal__dot--selected': activeSlide === 1 }"
        ></span>
        <span
          class="introduction-modal__dot introduction-modal__dot-spacing"
          (click)="goToSlide(2)"
          [ngClass]="{ 'introduction-modal__dot--selected': activeSlide === 2 }"
        ></span>
        <span
          class="introduction-modal__dot introduction-modal__dot-spacing"
          (click)="goToSlide(3)"
          [ngClass]="{ 'introduction-modal__dot--selected': activeSlide === 3 }"
        ></span>
        <span
          class="introduction-modal__dot introduction-modal__dot-spacing"
          (click)="goToSlide(4)"
          [ngClass]="{ 'introduction-modal__dot--selected': activeSlide === 4 }"
        ></span>
    </section>
      </div>
    </axs-modal-content>
  </dialog>
</axs-modal>

<!-- Slide Template -->
<ng-template
  #slide
  let-heading="heading"
  let-description="description"
  let-secondaryDescription="secondaryDescription"
  let-next="next"
  let-showUseTool="useTool"
  let-image="image"
>
  <section class="axs-flex-inner-wrapper--full-width introduction-modal__slide-wrapper sm-wrap-reverse row-gap-6">
    <div class="axs-lg-8 axs-md-8 axs-sm-16 introduction-modal__text-container">
      <h3
        class="introduction-modal__heading introduction-modal__move-in"
        [class.introduction-modal__heading--slide1]="activeSlide === 0"
      >
        {{ heading }}
      </h3>
      <p class="introduction-modal__description introduction-modal__move-in">{{ description }}</p>
      <p
        *ngIf="secondaryDescription"
        class="introduction-modal__description-secondary introduction-modal__move-in"
        [class.introduction-modal__description-secondary--slide1]="activeSlide === 0"
      >
        {{ secondaryDescription }}
      </p>
      
      <!-- Navigation Buttons -->
      <section class="introduction-modal__nav-buttons axs-flex-inner-wrapper--full-width">
        <section class="axs-flex-inner-wrapper--full-width justify-content-flex-start align-items-center">
          <ngx-axs-button
            *ngIf="(next || showUseTool) && activeSlide > 0"
            class="introduction-modal__button-spacing"
            [axsType]="'primary'"
            [axsTheme]="'black-outline'"
            [axsText]="modalContent?.backButton || 'Back'"
            [axsShowIcon]="true"
            [axsIconLeft]="true"
            [axsIconType]="'chevronLeft'"
            (axsClick)="goToSlide(activeSlide - 1)"
          ></ngx-axs-button>
          <ngx-axs-button
            *ngIf="next"
            [axsType]="'primary'"
            [axsText]="commonContent?.next || 'Next'"
            [axsShowIcon]="true"
            (axsClick)="goToSlide(activeSlide + 1)"
          ></ngx-axs-button>
          <ngx-axs-button
            *ngIf="showUseTool"
            [axsType]="'primary'"
            [axsTheme]="'vg-red'"
            [axsText]="modalContent?.getStarted || 'Get started'"
            [axsShowIcon]="true"
            (axsClick)="useTool()"
          ></ngx-axs-button>
        </section>
      </section>
    </div>
    
    <!-- Image Section -->
    <div class="axs-lg-8 axs-md-8 axs-sm-16 introduction-modal__image-container introduction-modal__fade-in">
      <img
        [src]="image"
        alt="Introduction modal slide visual"
      />
    </div>
  </section>
</ng-template>
